import React from 'react'
import styles from './LiveLogGraph.scss'
import {SampleGraph} from 'common/SampleGraph'
import {withMetricUnits} from 'common/units/MetricUnitsContext'
import {types} from '../reducer'

const MetricAwareSampleGraph = withMetricUnits(SampleGraph)

const SG_HEIGHT_CORRECTION = 25

export class LiveLogGraph extends React.PureComponent {
  static defaultProps = {
    mapPanelState: {}
  }

  render () {
    const {
      rawPoints,
      height,
      mapPanelState,
      mapPanelDispatch
    } = this.props

    const sgHeight = height + SG_HEIGHT_CORRECTION

    return (
      <div className={styles.sgFloat} style={{height}}>
        <div className={styles.wrap}>
          <MetricAwareSampleGraph
            onPointHighlighted={(point) => mapPanelDispatch({type: types.HIGHLIGHT_POINT, point})}
            highlightPoint={mapPanelState.highlightPoint}
            dragMode='select'
            height={sgHeight}
            rawPoints={rawPoints} />
        </div>
      </div>
    )
  }
}
